// 业务菜单
const menuData = {
  iconClass: "el-icon-menu",
  menuName: "业务管理",
  children: [
    {
      path: "/rhqy/service/home",
      menuName: "首页",
      privilege: "",
      iconClass: "el-icon-s-home"
    },
    {
      path: "/rhqy/service/report",
      menuName: "报表中心",
      privilege: "c-car-report-full-mgr&c-car-report-full-view",
      iconClass: "el-icon-s-data"
    },
    {
      path: "/rhqy/service/truck",
      menuName: "车辆安全放行",
      privilege: "",
      iconClass: "el-icon-s-claim",
      children: [
        {
          path: "/rhqy/service/truck/GateManage",
          menuName: "门口管理",
          privilege: "c-car-pass-entry-mgr&c-car-pass-entry-view"
        },
        {
          path: "/rhqy/service/truck/ReleaseList",
          menuName: "货车放行",
          privilege: "c-car-pass-pass-mgr&c-car-pass-pass-view"
        },
        {
          path: "/rhqy/service/truck/ReleaseLog",
          menuName: "放行日志",
          privilege: "c-car-pass-pass-logs"
        }
      ]
    },
    {
      path: "/rhqy/service/queue",
      menuName: "车辆排队管理",
      privilege: "",
      iconClass: "el-icon-truck",
      children: [
        {
          path: "/rhqy/service/queue/DeliveryList",
          menuName: "成品出厂",
          privilege:
            "c-car-qeue-ww-leave-call&c-car-qeue-ww-leave-truck&c-car-qeue-ww-leave-view&c-car-queue-leave-mgr&c-car-queue-leave-view"
        },
        {
          path: "/rhqy/service/queue/Log",
          menuName: "操作日志",
          privilege: "c-car-queue-logs-view"
        }
      ]
    },
    {
      path: "/rhqy/service/appoint",
      menuName: "车辆预约管理",
      privilege: "",
      iconClass: "el-icon-time",
      children: [
        {
          path: "/rhqy/service/appoint/serviceList",
          menuName: "预约业务管理",
          privilege: "c-car-apply-business-mgr&c-car-apply-business-view"
        },
        {
          path: "/rhqy/service/appoint/groupList",
          menuName: "预约业务组管理",
          privilege: "c-car-apply-businessgrp-mgr&c-car-apply-businessgrp-view"
        },
        {
          path: "/rhqy/service/appoint/timeTplList",
          menuName: "预约时间模板",
          privilege: "c-car-apply-model-mgr&c-car-apply-model-view"
        },
        {
          path: "/rhqy/service/appoint/timeCaseList",
          menuName: "预约时间实例",
          privilege: "c-car-apply-instance-mgr&c-car-apply-instance-view"
        },
        {
          path: "/rhqy/service/appoint/accordList",
          menuName: "预约记录管理",
          privilege: "c-car-apply-record-mgr&c-car-apply-record-view"
        },
        {
          path: "/rhqy/service/appoint/log",
          menuName: "操作日志",
          privilege: "c-car-apply-logs-view"
        }
      ]
    },
    {
      path: "/rhqy/service/coopera",
      menuName: "合作单位管理",
      privilege: "",
      iconClass: "el-icon-office-building",
      children: [
        {
          path: "/rhqy/service/coopera/CategoryManage",
          menuName: "类别管理",
          privilege: "c-coop-class-mgr&c-coop-class-view"
        },
        {
          path: "/rhqy/service/coopera/List",
          menuName: "单位管理",
          privilege: "c-coop-unit-mgr&c-coop-unit-view"
        },
        {
          path: "/rhqy/service/coopera/Log",
          menuName: "操作日志",
          privilege: "c-coop-logs-view"
        }
      ]
    },
    {
      path: "/rhqy/service/approval",
      menuName: "审批跳过情况汇总",
      privilege: "",
      iconClass: "el-icon-edit",
      children: [
        {
          path: "/rhqy/service/approval/category",
          menuName: "类别管理",
          privilege: "c-proc-pass-class-mgr&c-proc-pass-class-view"
        },
        {
          path: "/rhqy/service/approval/info",
          menuName: "消息管理",
          privilege:
            "c-proc-pass-msg-mgr&c-proc-pass-msg-view&c-ww-proc-pass-msg-view"
        }
      ]
    },
    {
      path: "/rhqy/service/store",
      menuName: "基础参数管理",
      privilege: "",
      iconClass: "el-icon-price-tag",
      children: [
        {
          path: "/rhqy/service/store/qrcode",
          menuName: "一码通管理",
          privilege: "c-base-data-code-view"
        },
        {
          path: "/rhqy/service/store/switch",
          menuName: "开关管理",
          privilege: "c-base-data-switch-mgr"
        },
        {
          path: "/rhqy/service/store/List",
          menuName: "装卸平台管理",
          privilege: "c-base-data-repo-mgr&c-base-data-repo-view"
        },
        {
          path: "/rhqy/service/safe/notice",
          menuName: "安全告知书设置",
          privilege: "c-base-data-safe-mgr"
        },
        {
          path: "/rhqy/service/store/Log",
          menuName: "操作日志",
          privilege: "c-base-data-logs-view"
        }
      ]
    }
  ]
};

export { menuData };
